import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { format, subMonths, subYears } from "date-fns";
import { formatPrice } from "../../../shared/utils/formatPrice";
import useStatisticOverview from "../../../services/statistic-data/hooks/useStatisticOverview";
import StatsCardSkeletonComponent from "../../pms-report/components/StatsCardSkeletonComponent";
import StatsCard from "./StatsCard";

// Tipe data untuk props
interface StatsData {
    title: string;
    value: string | number;
    subtitle: string;
    subtitleColor: string;
}

// Tipe data untuk props komponen
interface DashboardStatsGridProps {
    startDate: string;
    endDate: string;
}

const DashboardStatsGrid: React.FC<DashboardStatsGridProps> = ({ startDate, endDate }) => {
    const [statsData, setStatsData] = useState<StatsData[]>([]);

    // Menggunakan hook baru dengan filter yang diterima dari props
    const { data: statisticsData, isFetching } = useStatisticOverview({
        filters: {
            start_date: startDate,
            end_date: endDate,
        }
    });

    // Logika transformasi data dipindahkan ke sini
    useEffect(() => {
        if (statisticsData?.data) {
            const now = new Date();
            const lastMonth = subMonths(now, 1);
            const lastYear = subYears(now, 1);

            const payloadStatsData: StatsData[] = [
                {
                    title: "Number Of Reservations (This Month)",
                    value: statisticsData.data.total_booking,
                    subtitle: format(now, "MMMM yyyy"),
                    subtitleColor: "orange",
                },
                {
                    title: "Compared to Last Month",
                    value: statisticsData.data.total_booking_sub_month,
                    subtitle: format(lastMonth, "MMMM yyyy"),
                    subtitleColor: "teal",
                },
                {
                    title: "Compared to Last Year",
                    value: statisticsData.data.total_booking_sub_year,
                    subtitle: format(lastYear, "MMMM yyyy"),
                    subtitleColor: "teal",
                },
                {
                    title: "Total Revenue (This Month)",
                    value: formatPrice(statisticsData.data.total_revenue),
                    subtitle: format(now, "MMMM yyyy"),
                    subtitleColor: "orange",
                },
                {
                    title: "Compared to Last Month",
                    value: formatPrice(statisticsData.data.total_revenue_sub_month),
                    subtitle: format(lastMonth, "MMMM yyyy"),
                    subtitleColor: "teal",
                },
                {
                    title: "Compared to Last Year",
                    value: formatPrice(statisticsData.data.total_revenue_sub_year),
                    subtitle: format(lastYear, "MMMM yyyy"),
                    subtitleColor: "teal",
                },
            ];
            setStatsData(payloadStatsData);
        }
    }, [statisticsData]);


    return (
        <Row className="stats-cards">
            {isFetching && (
                <>
                    {Array.from({ length: 6 }).map((_, index) => (
                        <Col key={index} md={4} className="mb-4">
                            <StatsCardSkeletonComponent />
                        </Col>
                    ))}
                </>
            )}
            {!isFetching && statsData.length > 0 && statsData.map((stat, index) => (
                <Col key={index} md={4} className="mb-4">
                    <StatsCard
                        title={stat.title}
                        value={stat.value}
                        subtitle={stat.subtitle}
                        subtitleColor={stat.subtitleColor}
                    />
                </Col>
            ))}
        </Row>
    );
};

export default DashboardStatsGrid;